/**
 * 精彩课堂api
 */

import { getFetch, postFetch } from '@/plugins/http'
const baseHost = `${process.env.VUE_APP_HOST}/hike-boot`
// const baseHost = `https://sdau.zhihuishu.com/homepage/hike-boot` // 线上临时

export default {
  // 精彩课堂列表
  getWonderfulClassList(data) {
    return getFetch(`${baseHost}/api/liveManage/getWonderfulClassList`, data)
  },
  // 机器人跳转
  getAiReportUrl(data) {
    return getFetch(
      `${baseHost}/common/api/32-getAIClassroomTimeUrl/online_course_tour?mscId=${data.mscId}`
    )
  }
}
